import submission from './submission.js';
import autosave from './autosave.js';

var deleteSubmissionsAndAutosaves = function deleteSubmissionsAndAutosaves(userKey, cardstackKeys) {
  return Promise.all([submission.deleteSubmissions(cardstackKeys), autosave.deleteAutosaves(userKey, cardstackKeys)]);
};

export default {
  deleteSubmissionsAndAutosaves: deleteSubmissionsAndAutosaves
};